<template>
  <div
    :class="['v-image', isActive && 'v-image--active']"
    :style="{ backgroundImage: !!src && `url('${src}')` }"
    :aria-label="alt"
    role="img"
  ></div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false
    };
  },
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  display: none;

  &--active {
    display: block;
  }
}
</style>
